import { Link } from "react-router-dom";
import { articles } from "@/mocks/articles";
import SectionHeading from "@/components/feature/SectionHeading";

function HotContent() {
  const hot = articles.slice(0, 3);

  return (
    <section className="mx-auto w-full max-w-7xl px-4 py-14 md:px-6 md:py-20">
      <div className="flex flex-wrap items-end justify-between gap-4">
        <SectionHeading
          eyebrow="热度推荐"
          title="近期讨论最热的深度内容"
          desc="从剧情速览到结局考据，这里整理了读者们最近讨论最多的几篇内容，帮你快速追上社区节奏。"
        />
        <Link
          to="/plot"
          className="mb-8 inline-flex items-center gap-1 rounded-md px-3 py-2 text-sm font-medium text-primary-700 transition-colors hover:bg-primary-100 whitespace-nowrap"
        >
          查看全部 <i className="ri-arrow-right-line"></i>
        </Link>
      </div>

      <div className="grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3">
        {hot.map((a, idx) => (
          <Link
            key={a.id}
            to="/plot"
            className="group overflow-hidden rounded-lg border border-background-200/70 bg-background-50 transition-transform hover:-translate-y-1"
          >
            <div className="relative aspect-[3/2] overflow-hidden">
              <img
                src={a.image}
                alt={a.title}
                className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-105"
              />
              <span className="absolute left-3 top-3 rounded-md bg-primary-500 px-2.5 py-1 text-xs font-medium text-background-50">
                {a.category}
              </span>
              <span className="absolute right-3 top-3 flex h-8 items-center gap-1 rounded-md bg-black/40 px-2 text-xs font-medium text-background-50 backdrop-blur-sm">
                <i className="ri-heart-3-line text-primary-200"></i>
                {a.likes}
              </span>
            </div>
            <div className="p-5">
              <div className="flex items-center gap-2 text-xs text-foreground-500">
                <span>第 {idx + 1} 热门</span>
                <span className="text-background-300">·</span>
                <span>{a.date}</span>
                <span className="text-background-300">·</span>
                <span>{a.readTime}</span>
              </div>
              <h3 className="mt-3 font-heading text-lg font-bold text-foreground-950 transition-colors group-hover:text-primary-700">
                {a.title}
              </h3>
              <p className="mt-2 line-clamp-2 text-sm leading-relaxed text-foreground-600">
                {a.excerpt}
              </p>
              <span className="mt-4 inline-flex items-center gap-1 text-sm font-medium text-primary-600">
                阅读全文 <i className="ri-arrow-right-line transition-transform group-hover:translate-x-1"></i>
              </span>
            </div>
          </Link>
        ))}
      </div>
    </section>
  );
}

export default HotContent;